import axios from "axios";
import { apiErrorHandler } from "./helper/handler";

const prefix = "home-banner";

const GET_ALL_HOME_BANNER_URL = `${prefix}/all`;
const CREATE_HOME_BANNER_URL = `${prefix}/create`;
const UPDATE_HOME_BANNER_BY_ID_URL = `${prefix}/update-by-id`;
const DELETE_HOME_BANNER_BY_ID_URL = `${prefix}/delete-by-id`;

/**
 * @func getAllHomeBanner
 * @desc get all home banner data
 * @author izeberg
 * @param {AbortSignal} signal - AbortController Signal
 * @returns {Array} home banner array
 */
export const getAllHomeBanner = async (queryParams, signal) => {
    try {
        const { data, status } = await axios.get(GET_ALL_HOME_BANNER_URL, {
            params: queryParams,
            signal,
        });
        if (status === 200) {
            return data;
        }
        return undefined;
    } catch (error) {
        const err = apiErrorHandler(error, "getAllHomeBanner");
        if (err) throw err;
        return undefined;
    }
};
/** End @func getAllHomeBanner */

/**
 * @func createHomeBanner
 * @desc create new home banner
 * @author izeberg
 * @param {Object} body - create home banner body
 * @param {AbortSignal} signal - AbortController Signal
 * @returns {boolean} create status
 */
export const createHomeBanner = async (body, signal) => {
    try {
        const { status } = await axios.post(CREATE_HOME_BANNER_URL, body, {
            signal,
        });
        if (status === 201) {
            return true;
        }
        return undefined;
    } catch (error) {
        const err = apiErrorHandler(error, "createHomeBanner");
        if (err) throw err;
        return undefined;
    }
};
/** End @func createHomeBanner */

/**
 * @func updateHomeBannerById
 * @desc update home banner by id
 * @author izeberg
 * @param {number} id - home banner id
 * @param {Object} body - update home banner body
 * @param {AbortSignal} signal - AbortController Signal
 * @returns {boolean} update status
 */
export const updateHomeBannerById = async (id, body, signal) => {
    try {
        const { status } = await axios.put(`${UPDATE_HOME_BANNER_BY_ID_URL}/${id}`, body, {
            signal,
        });
        if (status === 200) {
            return true;
        }
        return undefined;
    } catch (error) {
        const err = apiErrorHandler(error, "updateHomeBannerById");
        if (err) throw err;
        return undefined;
    }
};
/** End @func updateHomeBannerById */

/**
 * @func deleteHomeBannerById
 * @desc delete home banner by id
 * @author izeberg
 * @param {Object} body - create home banner body
 * @param {AbortSignal} signal - AbortController Signal
 * @returns {Array} home banner array
 */
export const deleteHomeBannerById = async (id, signal) => {
    try {
        const { status } = await axios.delete(`${DELETE_HOME_BANNER_BY_ID_URL}/${id}`, {
            signal,
        });
        if (status === 200) {
            return true;
        }
        return undefined;
    } catch (error) {
        const err = apiErrorHandler(error, "deleteHomeBannerById");
        if (err) throw err;
        return undefined;
    }
};
/** End @func deleteHomeBannerById */
